import DataRoomNdasTable from './DataRoomNdasTable.component';

export default DataRoomNdasTable;